<template>
    <div class="container mb-8 mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">
            {{ __('Rendeléseim') }}
        </h1>
    </div>

    <div class="bg-white px-2 w-full" v-if="products">
        <div class="bg-highlight flex items-center justify-between px-2 py-4 text-white">
            <a class="cursor-pointer flex items-center text-lg text-white uppercase"
               v-on:click="prevWeek"
            >
                <c-icon class="h-6 mr-2 stroke-white w-6" icon="chevron-left" />
                <span class="hidden md:inline">{{ __('Előző') }}</span>
            </a>
            <span class="font-serif hidden text-3xl xl:inline">
                {{ __(':week. hét', { week: currentWeek }) }} <small class="font-sans text-base">({{ currentYear }})</small>
            </span>
            <span class="font-serif text-3xl xl:hidden">
                {{ DateTime.fromISO(currentDate).toFormat(localizationStore.dateFormat) }}
            </span>
            <a class="cursor-pointer flex items-center text-lg text-white uppercase"
               v-on:click="nextWeek"
            >
                <span class="hidden md:inline">{{ __('Következő') }}</span>
                <c-icon class="h-6 ml-2 stroke-white w-6" icon="chevron-right" />
            </a>
        </div>
        <div class="grid grid-cols-5 font-semibold px-2 text-center xl:grid-cols-10">
            <span class="flex items-center justify-center p-4"></span>
            <span class="border-l col-span-2 flex items-center justify-center p-4 xl:col-span-3">
                {{ __('Termék') }}
            </span>
            <span class="border-l hidden items-center justify-center p-4 xl:flex">
                {{ __('Ár') }}
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
            >
                {{ __('Hétfő') }}<br />
                <span class="hidden xl:block">{{ currentDays.monday.month }} {{ currentDays.monday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
            >
                {{ __('Kedd') }}
                <span class="hidden xl:block">{{ currentDays.tuesday.month }} {{ currentDays.tuesday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
            >
                {{ __('Szerda') }}
                <span class="hidden xl:block">{{ currentDays.wednesday.month }} {{ currentDays.wednesday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
            >
                {{ __('Csütörtök') }}
                <span class="hidden xl:block">{{ currentDays.thursday.month }} {{ currentDays.thursday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
            >
                {{ __('Péntek') }}
                <span class="hidden xl:block">{{ currentDays.friday.month }} {{ currentDays.friday.day }}</span>
            </span>
        </div>
        <div v-for="product in products">
            <div class="border-t grid grid-cols-5 px-2 xl:grid-cols-10"
                 v-if="showProduct(product, currentYear + '.' + currentWeek)"
            >
                <span class="flex items-center justify-center p-1">
                    <img class="max-w-32 w-full" v-bind:alt="product.name" v-bind:src="product.picture" />
                </span>
                <span class="border-l col-span-2 flex flex-col items-start justify-center p-4 xl:col-span-3">
                    <strong class="block text-slate-800 text-sm">{{ product.name }}</strong>
                    <span class="mt-1 text-slate-500 text-xs">{{ product.description }}</span>

                    <div class="flex flex-col xl:hidden" v-if="product.prices[`${user.group_id}`]">
                        <span class="mt-4">
                            {{ currencyStore.format(product.prices[`${user.group_id}`], 'huf') }}
                        </span>

                        <span class="text-xs" v-if="product.prices[`${user.group_id}`]">
                            ({{ currencyStore.format(product.prices[`${user.group_id}`] / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                    <div class="flex flex-col xl:hidden" v-else>
                        <span class="mt-4">
                            {{ currencyStore.format(product.price_gross, 'huf') }}
                        </span>

                        <span class="text-xs">
                            ({{ currencyStore.format(product.price_gross / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                </span>
                <span class="border-l hidden items-center justify-center p-4 text-center xl:flex">
                    <div class="flex flex-col" v-if="product.prices[`${user.group_id}`]">
                        <span>
                            {{ currencyStore.format(product.prices[`${user.group_id}`], 'huf') }}
                        </span>

                        <span class="text-xs">
                            ({{ currencyStore.format(product.prices[`${user.group_id}`] / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                    <div class="flex flex-col" v-else>
                        <span>{{ currencyStore.format(product.price_gross, 'huf') }}</span>

                        <span class="text-xs">
                            ({{ currencyStore.format(product.price_gross / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
                >
                    <div class="flex items-center">
                        <span class="block border-2 border-highlight flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                              v-if="product.quantity[`${currentYear}.${currentWeek}`].monday > 0"
                        >
                            {{ product.quantity[`${currentYear}.${currentWeek}`].monday }}
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
                >

                    <div class="flex items-center">
                        <span class="block border-2 border-highlight flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                              v-if="product.quantity[`${currentYear}.${currentWeek}`].tuesday > 0"
                        >
                            {{ product.quantity[`${currentYear}.${currentWeek}`].tuesday }}
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                             v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
            >

                    <div class="flex items-center">
                        <span class="block border-2 border-highlight flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                              v-if="product.quantity[`${currentYear}.${currentWeek}`].wednesday > 0"
                        >
                            {{ product.quantity[`${currentYear}.${currentWeek}`].wednesday }}
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                             v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
            >

                    <div class="flex items-center">
                        <span class="block border-2 border-highlight flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                              v-if="product.quantity[`${currentYear}.${currentWeek}`].thursday > 0"
                        >
                            {{ product.quantity[`${currentYear}.${currentWeek}`].thursday }}
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                             v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
            >

                    <div class="flex items-center">
                        <span class="block border-2 border-highlight flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                              v-if="product.quantity[`${currentYear}.${currentWeek}`].friday > 0"
                        >
                            {{ product.quantity[`${currentYear}.${currentWeek}`].friday }}
                        </span>
                    </div>
                </span>
            </div>
        </div>
        <div class="font-bold py-4 text-center"
             v-if="!hasAvailableProducts(currentYear + '.' + currentWeek)"
        >
            {{ __('Nem történt rendelés ezen a héten.') }}
        </div>

        <div class="bg-highlight font-semibold grid grid-cols-5 items-center mt-4 px-2 text-xl text-center text-white uppercase xl:grid-cols-10">
            <span class="col-span-3 px-4 py-2 xl:col-span-5">{{ __('Összesen') }}</span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
            >
                {{ currencyStore.format(totalPrice.monday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.monday.net">
                    {{ currencyStore.format(totalPrice.monday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
            >
                {{ currencyStore.format(totalPrice.tuesday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.tuesday.net">
                    {{ currencyStore.format(totalPrice.tuesday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
            >
                {{ currencyStore.format(totalPrice.wednesday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.wednesday.net">
                    {{ currencyStore.format(totalPrice.wednesday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
            >
                {{ currencyStore.format(totalPrice.thursday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.thursday.net">
                    {{ currencyStore.format(totalPrice.thursday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
            >
                {{ currencyStore.format(totalPrice.friday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.friday.net">
                    {{ currencyStore.format(totalPrice.friday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, inject, onMounted, ref } from 'vue';
    import {
        CIcon,
    } from '@teamfurther/cinderblock';
    import { DateTime } from 'luxon';
    import OrderRepository from '../../repositories/OrderRepository';
    import ProductRepository from '../../repositories/ProductRepository';
    import { useCurrencyStore } from '../../stores/currency';
    import { useLocalizationStore } from '../../stores/localization';
    import { useRequestStore } from '../../stores/request';
    import { useSessionStore } from '../../stores/session';

    const __ = inject('__');
    const breakpoint = 1280;
    const currencyStore = useCurrencyStore();
    const currentBreakpoint = ref(window.innerWidth);
    const currentDate = ref(DateTime.now().setLocale('en'));
    const localizationStore = useLocalizationStore();
    const currentDays = computed(() => {
        const firstDay = currentDate.value.startOf('week');

        return {
            monday: {
                date: firstDay,
                day: firstDay.day,
                month: firstDay.setLocale(localizationStore.locale).toFormat('MMM')
            },
            tuesday: {
                date: firstDay.plus({ days: 1 }),
                day: firstDay.plus({ days: 1 }).day,
                month: firstDay.plus({ days: 1 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
            wednesday: {
                date: firstDay.plus({ days: 2 }),
                day: firstDay.plus({ days: 2 }).day,
                month: firstDay.plus({ days: 2 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
            thursday: {
                date: firstDay.plus({ days: 3 }),
                day: firstDay.plus({ days: 3 }).day,
                month: firstDay.plus({ days: 3 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
            friday: {
                date: firstDay.plus({ days: 4 }),
                day: firstDay.plus({ days: 4 }).day,
                month: firstDay.plus({ days: 4 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
        }
    });
    const currentWeek = computed(() => {
        return currentDate.value.weekNumber;
    });
    const currentYear = computed(() => {
        return currentDate.value.year;
    });
    const order = ref();
    const orderRepository = new OrderRepository();
    const productRepository = new ProductRepository();
    const products = ref();
    const totalPrice = computed(() => {
        let total = {
            monday: { net: 0, gross: 0 },
            tuesday: { net: 0, gross: 0 },
            wednesday: { net: 0, gross: 0 },
            thursday: { net: 0, gross: 0 },
            friday: { net: 0, gross: 0 },
        };

        products.value.forEach((product) => {
            const price = product.prices[user.value.group_id] ?? product.price_gross;

            const mondayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['monday'] ?? 0;
            total.monday.gross += mondayQty * price;
            total.monday.net += mondayQty * price / (1 + product.vat_pct / 100);

            const tuesdayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['tuesday'] ?? 0;
            total.tuesday.gross += tuesdayQty * price;
            total.tuesday.net += tuesdayQty * price / (1 + product.vat_pct / 100);

            const wednesdayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['wednesday'] ?? 0;
            total.wednesday.gross += wednesdayQty * price;
            total.wednesday.net += wednesdayQty * price / (1 + product.vat_pct / 100);

            const thursdayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['thursday'] ?? 0 * price;
            total.thursday.gross += thursdayQty * price;
            total.thursday.net += thursdayQty * price / (1 + product.vat_pct / 100);

            const fridayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['friday'] ?? 0;
            total.friday.gross += fridayQty * price;
            total.friday.net += fridayQty * price / (1 + product.vat_pct / 100);
        });

        return total;
    });
    const sessionStore = useSessionStore();
    const user = ref(sessionStore.user);

    function addMissingQuantityData() {
        products.value.forEach((product) => {
            if (!product.quantity) {
                product.quantity = {};
            }

            if (!product.quantity[`${currentYear.value}.${currentWeek.value}`]) {
                product.quantity[`${currentYear.value}.${currentWeek.value}`] = {
                    monday: 0,
                    tuesday: 0,
                    wednesday: 0,
                    thursday: 0,
                    friday: 0,
                };
            }
        });
    }

    async function getOrder() {
        const orders = await orderRepository.index({
            filters: {
                user_id: user.value.id,
                week: currentYear.value + '.' + currentWeek.value,
            },
            include: ['items']
        });

        order.value = orders[0];

        if (order.value && order.value.items.length > 0) {
            order.value.items.forEach((item) => {
                products.value.forEach((product) => {
                    if (product.id === item.product_id) {
                        if (!product.quantity[order.value.year + '.' + order.value.week]) {
                            product.quantity[order.value.year + '.' + order.value.week] = {};
                        }

                        product.quantity[order.value.year + '.' + order.value.week][item.day] = item.quantity;
                    }
                });
            });
        }
    }

    async function getProducts() {
        products.value = await productRepository.index({
            filters: {
                active: true,
            },
        });

        addMissingQuantityData();
    }

    function hasAvailableProducts(week) {
        let found = false;

        products.value.forEach(product => {
            if (showProduct(product, week)) {
                found = true;
            }
        });

        return found;
    }

    async function nextWeek() {
        currentDate.value = breakpoint < currentBreakpoint.value
            ? currentDate.value.plus({ weeks: 1 })
            : currentDate.value.plus({ days: 1 });

        if (currentDate.value.weekday === 6) {
            currentDate.value = currentDate.value.plus({ day: 2 });
        }

        addMissingQuantityData();
        await getOrder();
    }

    async function prevWeek() {
        currentDate.value = breakpoint < currentBreakpoint.value
            ? currentDate.value.minus({ weeks: 1 })
            : currentDate.value.minus({ days: 1 });

        if (currentDate.value.weekday === 7) {
            currentDate.value = currentDate.value.minus({ day: 2 });
        }

        addMissingQuantityData();
        await getOrder();
    }

    function showProduct(product, week) {
        return product.quantity[`${week}`].monday > 0
            || product.quantity[`${week}`].tuesday > 0
            || product.quantity[`${week}`].wednesday > 0
            || product.quantity[`${week}`].thursday > 0
            || product.quantity[`${week}`].friday > 0;
    }

    onMounted(async () => {
        await getProducts();

        window.addEventListener('resize', () => {
            currentBreakpoint.value = window.innerWidth;
        });

        if (currentDate.value.weekday === 6) {
            currentDate.value = currentDate.value.plus({ day: 2 });
        } else if (currentDate.value.weekday === 7) {
            currentDate.value = currentDate.value.plus({ day: 1 });
        }

        await getOrder();
    });
</script>
